const emailChanges = [
    {
        id: 1,
        oldEmail: "shahjahan.swajan@myelinh.com",
        newEmail: "shahjahan.swajan@myelinz.com",
    },
    {
        id: 2,
        oldEmail: "zied.tayeb@myelinh.com",
        newEmail: "zied@myelinz.com",
    },
    {
        id: 3,
        oldEmail: "samaher.garbaya@myelinh.com",
        newEmail: "samaher@myelinz.com",
    },
    {
        id: 4,
        oldEmail: "bernhard.specht@myelinh.com",
        newEmail: "bernhard.specht@myelinz.com",
    },
    {
        id: 5,
        oldEmail: "muhammed.nasser@myelinh.com",
        newEmail: "muhammed.nasser@myelinz.com",
    },
    {
        id: 6,
        oldEmail: "abdelrahman.ghanam@myelinh.com",
        newEmail: "abdelrahman.ghanam@myelinz.com",
    },
    {
        id: 7,
        oldEmail: "alexandra.risberg@myelinh.com",
        newEmail: "alexandra.risberg@myelinz.com",
    },
    {
        id: 8,
        oldEmail: "ali.stuckey@myelinh.com",
        newEmail: "ali.stuckey@myelinz.com",
    },
    {
        id: 9,
        oldEmail: "ananya.nair@myelinh.com",
        newEmail: "ananya.nair@myelinz.com",
    },
    {
        id: 10,
        oldEmail: "jaysmi.badole@myelinh.com",
        newEmail: "jaysmi.badole@myelinz.com",
    },
    {
        id: 11,
        oldEmail: "jignesh.patel@myelinh.com",
        newEmail: "jignesh.patel@myelinz.com",
    },
    {
        id: 12,
        oldEmail: "krushanu.waghmare@myelinh.com",
        newEmail: "krushanu.waghmare@myelinz.com",
    },
    {
        id: 13,
        oldEmail: "mohammad.elkhozondar@myelinh.com",
        newEmail: "mohammad.elkhozondar@myelinz.com",
    },
    {
        id: 14,
        oldEmail: "shahvaiz.jahangeer@myelinh.com",
        newEmail: "shahvaiz.jahangeer@myelinz.com",
    },
    {
        id: 15,
        oldEmail: "zohair.kharal@myelinh.com",
        newEmail: "zohair.kharal@myelinz.com",
    },
    {
        id: 16,
        oldEmail: "kunal.aggarwal@myelinz.com",
        newEmail: "kunal.aggarwal@myelinz.com",
    }
];

export default emailChanges;
